import type React from 'react';

import { ModalHeader, Text } from '@change/ds-core-ui';
import { FacebookRegularIcon as FacebookIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

export const ModalTitle: React.FC<{ onClose: () => void }> = ({ onClose }) => {
	return (
		<ModalHeader
			title={
				<div className="flex items-center gap-[8px]">
					<div className="bg-background-base flex h-6 w-6 items-center justify-center rounded-full text-[#1877F2]">
						<FacebookIcon className="h-full w-full" svgClassName="w-full h-full" />
					</div>
					<Text fontWeight="bold" variant="body" size="x-large">
						<Translate value="corgi.petition.starter_dashboard_v2.ready_to_share.share_preview_modal.title" />
					</Text>
				</div>
			}
			close={onClose}
		></ModalHeader>
	);
};
